import React, { Component } from 'react'
import { FormInput, Modal } from '../../components'
import { connect } from 'react-redux'
import { back } from '../../actions/nav-actions'
import { createActivity } from '../../api';
import { notify } from '../../utils';

class Activities extends Component {
    state = {
        name: ''
    }
    request() {
        const params = this.props.match.params || {};
        let { name } = this.state;
        this.setState({ name: '' }, () => {
            createActivity(
                this.props.user.token,
                params.organization,
                params.code,
                {
                    name
                }
            )
                .then((type) => this.props.back())
                .catch(err => notify('Error', err.message, 'error'));
        });
    }
    render() {
        return (
            <Modal
                title="Activities"
                onClose={this.props.back}
                hideActions={true}
                visible={true}>
                <FormInput
                    onChange={text => this.setState({ name: text })}
                    value={this.state.name} />
                <div className="text-center">
                    <button onClick={this.request.bind(this)} className="btn btn-info">SAVE</button>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({
    user: state.authReducer.user
});

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Activities);


// WEBPACK FOOTER //
// ./src/routers/Projects/Activities.js